/* unplugin-vue-components disabled */import { render } from "./ReviewAnswerCard.vue?vue&type=template&id=ebdbfda2&scoped=true"
import script from "./ReviewAnswerCard.vue?vue&type=script&lang=js"
export * from "./ReviewAnswerCard.vue?vue&type=script&lang=js"

import "./ReviewAnswerCard.vue?vue&type=style&index=0&id=ebdbfda2&lang=scss&scoped=true"
import "./ReviewAnswerCard.vue?vue&type=style&index=1&id=ebdbfda2&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdbfda2"]])

export default __exports__